import React, { useState } from "react";
import { Form, Button, Container, Row, Col, Nav } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useSignupMutation, useSendOtpMutation } from "../slices/usersApiSlice";
import { toast } from "react-toastify";
import { parseUserInfo } from "../utils/parseUtil";

const SignupScreen = () => {
  const [userId, setUserId] = useState("");
  // const [empCode, setEmpCode] = useState('')
  const navigate = useNavigate();

  const [signup, { isLoading }] = useSignupMutation();
  const [sendOtp, { isLoading: sendOtpLoading }] = useSendOtpMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("ReqUserID", userId);
    formData.append("ReqPassWord", "");
    formData.append("description", "GetStaffDetails");
    formData.append("title", "GetStaffInfoJason");
    formData.append("ReqType", "CreateLogin");

    try {
      const res = await signup(formData);
      const parsedUserInfo = parseUserInfo(res);

      if (parsedUserInfo) {
        const infoField1 = parsedUserInfo[0]?.InfoField1;
        const empcode = parsedUserInfo[1]?.InfoField;
        const userId = parsedUserInfo[0]?.InfoField2;
        const companyCode = parsedUserInfo[13]?.InfoField;
        const userName = parsedUserInfo[2]?.InfoField;

        if (infoField1 === "0") {
          // Store user information in localStorage
          localStorage.setItem("userId", userId);
          localStorage.setItem("companyCode", companyCode);
          localStorage.setItem("userName", userName);
          const SMSTYPE = process.env.REACT_APP_SMS_TYPE || "";

          const otpFormData = new FormData();
          otpFormData.append("title", "SentVerificationCodeStaff");
          otpFormData.append("description", "SentVerificationCodeStaff");
          otpFormData.append("ReqUserID", userId);
          otpFormData.append("ReqCompanyCode", companyCode);
          otpFormData.append("ReqSMSType", SMSTYPE);

          for (let [key, value] of otpFormData.entries()) {
            console.log(`${key}: ${value}`);
          }

          await sendOtp(otpFormData);
          navigate("/otp", { state: { userId, companyCode, userName } });
        } else {
          toast.error(parsedUserInfo[0]?.InfoField || "Login & Active Staff Record Found");
        }
      } else {
        toast.error("Failed to parse user info");
      }
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <Container className="form-container mt-5">
      <Row className="justify-content-md-center">
        <Col md={6}>
          <h3 className="mt-4 text-center form-title">Sign Up</h3>
          <Form className="border p-4 rounded form-background" onSubmit={handleSubmit}>
            <Form.Group controlId="userId" className="mb-3">
              <Form.Label>Used ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter User ID"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                required
                className="form-control-hover"
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3 btn-custom">
              Signup
            </Button>
            <p className="pt-3 text-center">
              Back to{" "}
              <Nav.Link as={Link} to="/login" className="d-inline p-0">
                <span className="text-primary text-decoration-underline">Login</span>
              </Nav.Link>
            </p>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default SignupScreen;
